import React from 'react';
import * as R from 'unitx/ramda';
export default ((ref, defaultValue = null, getAttachments = () => ({})) => {
  // @ts-ignore
  const currentRef = React.useRef( // @ts-ignore
  defaultValue); // @TODO:TESTING
  // React.useImperativeHandle(
  //   ref,
  //   // @ts-ignore
  //   () => ({
  //     ...currentRef.current ?? {},
  //     ...getAttachments(currentRef),
  //   }),
  //   [currentRef.current, ref],
  // )
  // @TODO:TESTING_END

  React.useEffect(() => {
    R.pipe(R.when(R.pipe(R.prop('current'), R.isNotNil), R.always(R.mapObjIndexed((val, key) => {
      // @ts-ignore
      // @ts-ignore
      currentRef.current[key] = val;
    })(getAttachments(currentRef)))), () => R.cond([// @ts-ignore
    [R.isFunction, () => ref(currentRef.current)], // @ts-ignore
    // eslint-disable-next-line no-param-reassign
    [R.isObject, () => {
      // @ts-ignore
      ref.current = currentRef.current;
    }]])(ref), R.always(R.identity))(currentRef);
  }, [ref, currentRef.current]);
  return currentRef;
});